import { Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { SignupPromptService } from '../../core/services/signup-prompt.service';
import { IconComponent } from '../../shared/components/icon/icon.component';
import { RevealDirective } from '../../shared/directives/reveal.directive';

/**
 * PPC/marketing landing page for seller-acquisition ad groups (distinct from
 * the header's "Sell a Saddle" nav link, which sends already-oriented users
 * straight to the listing form). Public — no guard.
 */
@Component({
  selector: 'app-sell',
  standalone: true,
  imports: [RouterLink, IconComponent, RevealDirective],
  templateUrl: './sell.component.html',
})
export class SellComponent {
  private readonly router = inject(Router);
  private readonly signupPromptService = inject(SignupPromptService);
  private readonly authService = inject(AuthService);

  startListing(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/account/listings/new']);
      return;
    }
    this.signupPromptService.show(
      'Create a free account to list your saddle — it only takes a minute.',
    );
  }
}
